// @flow
import type { Node } from 'react';

type InterventionsLayoutProps = {
  children: Node,
};

const InterventionsLayout = ({ children }: InterventionsLayoutProps): React$Node => {
  const items = Array.isArray(children) ? children : [children];
  const [weeks, participants, filter] = items;

  return (
    <div className="interventions container">
      { filter && (
        <div className="interventions-period-filter-slot">
          { filter }
        </div>
      ) }
      <div className="interventions-weeks">
        { weeks }
      </div>
      <div className="interventions-participants">
        { participants }
      </div>
    </div>
  );
};

export default InterventionsLayout;
